const MembershipBannerText = () => (
  <p className="leading-[140%] tracking-[0.32px] mt-4">
    Get access to a personal advisor to help navigate all aspects of forest
    ownership.
  </p>
)

export default MembershipBannerText
